// =============================================================================
// DEFENSIVE PATCH: Prevent errors from debug monitors and browser extensions
// This MUST run BEFORE any other code
// =============================================================================
(function() {
  const _postMessage = window.postMessage.bind(window);

  window.postMessage = function(message, targetOrigin, transfer) {
    try {
      // Normalize targetOrigin - fix "Invalid target origin 'undefined'" error
      if (typeof targetOrigin !== "string" || targetOrigin.trim() === "") {
        targetOrigin = "*";
      }

      // Normalize message to avoid DataCloneError with Request objects
      if (message instanceof Request) {
        message = {
          __type: "Request",
          url: message.url,
          method: message.method,
          headers: Object.fromEntries(message.headers.entries()),
        };
      }

      // Handle nested Request objects
      if (message && typeof message === "object" && !(message instanceof MessagePort)) {
        try {
          if (message.request instanceof Request) {
            message = {
              ...message,
              request: {
                __type: "Request",
                url: message.request.url,
                method: message.request.method,
                headers: Object.fromEntries(message.request.headers.entries()),
              },
            };
          }
        } catch (e) {
          // Ignore nested check errors
        }
      }

      return _postMessage(message, targetOrigin, transfer);
    } catch (err) {
      // Swallow ALL errors - never throw from patch
      console.warn("[postMessage patch] swallowed error:", err.message || err);
      return;
    }
  };
})();

// =============================================================================
// MAIN APP ENTRY
// =============================================================================
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
